<template>
  <div class="tags">
    <spinner v-if="loading" />
    <breadcrumb :links="breadcrumb" />
    <div class="pageContent">
      <heading-wrap>
        <span slot="title">Tag Group Name: {{ this.tagCollection.name }} </span>
      </heading-wrap>
      <form-group class="pull-right">
        <button @click="downloadCsvGroupUrl(tagEntryId)" class="btn btn-success">Download all TAGs (.csv)</button>
        <button @click="downloadTxtGroupUrl(tagEntryId)" class="btn btn-primary">Download all TAGs (.txt)</button>
      </form-group>
      <div class="row">
        <div class="col-sm-6">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title">Client: <router-link :to="{ path: `/client/${this.tagCollection.creative.campaign.client.hash_id}` }">{{ this.tagCollection.creative.campaign.client.name }}</router-link></h5>
              <h5 class="card-title">Campaign: <router-link :to="{ path: `/campaigns/${this.tagCollection.creative.campaign.hash_id}` }">{{ this.tagCollection.creative.campaign.name }}</router-link></h5>
              <h5 class="card-title">Creative: <router-link :to="{ path: `/creatives/${this.tagCollection.creative.hash_id}/bulk` }">{{ this.tagCollection.creative.name }}</router-link></h5>
              <h5 class="card-title">Tag Entry ID:  {{ tagEntryId }}</h5>
            </div>
          </div>
        </div>
      </div>
      <div v-for="(entry, key) in this.tagCollection.entries" :key="key" class="row">
        <hr/>
        <div class="col-md-4">
          <h3>Tag {{ entry.master }} - {{ entry.locale }}</h3>
          <h4>Tag Status: {{ entry.status }}</h4>
          <div v-if="tagReady(entry.status)">
            <h4>Tag Code</h4>
            <pre class="tagcode">
              <code :id="'tag' + key">{{ entry.tag_code }}</code>
            </pre>
            <div class="form-group">
              <button :id="'copy' + key" class="btn btn-warning" @click="copyTag(key)">Copy TAG to clipboard</button>
              <button @click="downloadTxtUrl(entry.hash_id)" class="btn btn-primary">Download TAG (.txt)</button>
            </div>
          </div>
        </div>
        <div v-if="tagReady(entry.status)" class="col-md-8">
          <h4>Preview</h4>
          <iframe :src="entry.full_url" :height="entry.height" :width="entry.width" no-border style="overflow:hidden;background:grey;" seamless="" scrolling="no" frameborder="0"></iframe>
        </div>
      </div>
    </div>
    <portal to="globalModal">
      <modal-tag-confirm :show="showModal.deleteTag" :type="modalType" :confirmId="modalId" @close="toggleModal('deleteTag')"/>
      <modal-edit-tag :show="showModal.editTag" :type="modalType" :confirmId="modalId" :field="modalField" @close="toggleModal('editTag')"/>
      <modal-refresh-tag :show="showModal.refreshTag" :type="modalType" :confirmId="modalId" @close="toggleModal('refreshTag')"/>
    </portal>
  </div>
</template>

<script>
import HeadingWrap from '@/components/HeadingWrap/heading-wrap'
import ButtonCta from '@/components/Button/button'
import Modal from '@/components/Modal/modal'
import ShareUrlBox from '@/components/ShareUrlBox/share-url-box'
import SlotTable from '@/components/Table/table'
import Spinner from '@/components/SpinnerIcon/spinner'
import SearchBox from '@/components/SearchBox/searchbox'
import ProgressBar from '@/components/ProgressBar/progress-bar'
import ModalTagConfirm from '@/components/Modal/tags/modal-tag-confirm'
import ModalEditTag from '@/components/Modal/tags/modal-edit-tag'
import ModalRefreshTag from '@/components/Modal/tags/modal-refresh-tag'
import Breadcrumb from '@/components/Breadcrumb/breadcrumb'
import {modalMixin} from '@/mixins/modalMixin'
import {tagMixin} from '@/mixins/tagMixin'
import {downloadMixin} from '@/mixins/downloadMixin'
import {notificationMixin} from '@/mixins/notificationMixin'

import { url, API_URL } from '@/config'

const NOTIFICATION_DELAY = 8000

export default {
  name: 'Tags',
  mixins: [modalMixin, tagMixin, notificationMixin, downloadMixin],
  components: {
    HeadingWrap,
    ShareUrlBox,
    ButtonCta,
    Modal,
    SlotTable,
    Spinner,
    SearchBox,
    ProgressBar,
    ModalTagConfirm,
    ModalEditTag,
    ModalRefreshTag,
    Breadcrumb
  },
  props: {
    tableData: Array
  },
  data: () => ({
    search: '',
    table: {
      columns: {
        name: 'Name',
        date: 'Date Created',
        client: 'Client',
        status: 'Status',
        ad_tag_count: 'Creatives',
        campaign: 'Campaign Name',
        creative: 'Creative Name',
        tagActions: ''
      }
    },
    tagCollection: Object
  }),
  mounted () {
    this.getTag(this.tagEntryId).then((response) => {
      this.finishLoading()
      this.tagCollection = response
    })
  },
  computed: {
    tagEntryId () {
      return this.$route.params.id
    },
    breadcrumb () {
      if (this.tagCollection.creative) {
        return [
          {
            name: this.tagCollection.creative.campaign.client.name,
            path: `client/${this.tagCollection.creative.campaign.client.hash_id}`
          },
          {
            name: this.tagCollection.creative.campaign.name,
            path: `campaigns/${this.tagCollection.creative.campaign.hash_id}`
          },
          {
            name: this.tagCollection.creative.name,
            path: `creatives/${this.tagCollection.creative.hash_id}/bulk`
          },
          {
            name: 'tag',
            path: '',
            active: true
          }
        ]
      }
    }
  },
  methods: {
    tagReady (status) {
      var ready = ['completed', 'locked', 'trafficked']
      return (ready.indexOf(status) > -1)
    },
    previewUrl (path) {
      return url + path
    },
    showNotMessage (type, text) {
      const notification = this.addNotification('danger', text)
      setTimeout(() => {
        this.closeLastNotification(notification.id)
      }, NOTIFICATION_DELAY) // Wait 8 seconds to remove the notification
    },
    downloadTxtUrl (hashId) {
      this.startLoading()
      this.createSignedDownloadRequest({
        domain: 'adtag-entry',
        resource: hashId,
        extension: 'txt'
      }).then(response => {
        this.finishLoading()
        if (!response.success) {
          this.showNotMessage('error', 'Try again later')
          return
        }
        window.open(API_URL + response.link.substring(1))
      }).catch(reason => {
        this.finishLoading()
        this.showNotMessage('error', reason)
      })
    },
    downloadTxtGroupUrl (hashId) {
      this.startLoading()
      this.createSignedDownloadRequest({
        domain: 'adtag-group',
        resource: hashId,
        extension: 'txt'
      }).then(response => {
        this.finishLoading()
        if (!response.success) {
          this.showNotMessage('error', 'Try again later')
          return
        }
        window.open(API_URL + response.link.substring(1))
      }).catch(reason => {
        this.finishLoading()
        this.showNotMessage('error', reason)
      })
    },
    downloadCsvGroupUrl (hashId) {
      this.startLoading()
      this.createSignedDownloadRequest({
        domain: 'adtag-group',
        resource: hashId,
        extension: 'csv'
      }).then(response => {
        this.finishLoading()
        if (!response.success) {
          this.showNotMessage('error', 'Try again later')
          return
        }
        window.open(API_URL + response.link.substring(1))
      }).catch(reason => {
        this.finishLoading()
        this.showNotMessage('error', reason)
      })
    },
    copyTag (key) {
      var content = document.getElementById('tag' + key)
      const el = document.createElement('textarea')
      el.value = content.innerText
      el.setAttribute('readonly', '')
      el.style.position = 'absolute'
      el.style.left = '-9999px'
      document.body.appendChild(el)
      const selected =
      document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      this.isCopied = true
      if (selected) {
        document.getSelection().removeAllRanges()
        document.getSelection().addRange(selected)
      }
      var copyButton = document.getElementById('copy' + key)
      copyButton.innerHTML = 'Tag Copied!'
      copyButton.classList.remove('btn-warning')
      copyButton.classList.add('btn-success')
    }
  }
}
</script>

<style lang="scss">
  .tags {
    .headingWrap__title {
      width:75%;
    }
    .debugInfo {
      display: none;
      border: 1px solid grey;
      background: black;
      color:limegreen;
      padding:20px;
      word-wrap: break-word;
      border-radius:5px;
    }
    .debugInfo h3 {
      color:pink;
    }
    .showDebug {
      display: block;
    }
    pre {
      white-space: unset;
    }
    pre code {
      color: #c7254e;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/tags/detail.vue